<template>
  <v-tooltip top>
    <template v-slot:activator='{ on }'>
      <v-avatar
        v-on='on'
        :size='26'
        color='info'
        class='white--text text-uppercase'
      >
        <small>{{ displayText }}</small>
      </v-avatar>
    </template>
    <span class='caption'>{{ profile ? profile.name_display : "user not set" }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'avatar',
  props: {
    profile: {
      required: false
    }
  },
  computed: {
    displayText () {
      if (this.profile) {
        let ret = this.profile.first_name.charAt(0)
        ret = this.profile.last_name ? ret += this.profile.last_name.charAt(0) : ret
        return ret
      }
      return "??"
    }
  }
}
</script>
